/*
  LeftSidebar.jsx
*/

// Npm.
import React from 'react';

// Components.
import Sidebar from '../../Sidebar';
import SettingsSection from './SettingsSection';
import ActionsSection from './ActionsSection';
import TagsSection from './TagsSection';

// Makes.
import { makeStyles } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  content: {
    '& > .section': {
      marginBottom: theme.space(4),
      '& > .title': {
        color: theme.color_primary_main,
        marginBottom: theme.space(2),
      }
    }
  },
}));

/**
 * Left sidebar component.
 */
export default function LeftSidebar({
  className,
  disableThemeToggle = false,
  open = false,
  disabled = false,
  isSmall = false,
  canvasRef,
  forceGraphRef,
  graphData,
  graphSettings,
  tagFilter,
  onChangeGraphSettings,
  onChangeTagFilter,
  onClose,
  ...rest
}) {

  const classes = useStyles();

  function changeSettings(fields) {
    if (onChangeGraphSettings) {
      onChangeGraphSettings(obj => ({ ...obj, ...fields }));
    }
  }

  const titleClass = 'title overline';

  return (
    <Sidebar
      className={className}
      title="Settings"
      position="left"
      variant={isSmall ? 'temporary' : 'permanent'}
      open={open}
      onClose={onClose}
      disabled={disabled}
    >
      <div className={classes.content}>

        <div className="section">
          <p className={titleClass}>
            UI Settings
          </p>
          <SettingsSection
            graphSettings={graphSettings}
            onChangeGraphSettings={onChangeGraphSettings}
            disableThemeToggle={disableThemeToggle}
            disabled={disabled}
          />
        </div>

        <div className="section">
          <p className={titleClass}>
            Actions
          </p>
          <ActionsSection
            canvasRef={canvasRef}
            forceGraphRef={forceGraphRef}
            disabled={disabled}
          />
        </div>

        <div className="section">
          <p className={titleClass}>
            Tags
          </p>
          <TagsSection
            graphData={graphData}
            tagFilter={tagFilter}
            onChangeTagFilter={onChangeTagFilter}
            disabled={disabled}
          />
        </div>

      </div>
    </Sidebar>
  );
}
